import React from "react"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"

const Highlights = () => {
  const { t } = useTranslation()

  // This is placeholder data. Replace it with actual data from your blog posts.
  const posts = [
    {
      title: t("introvert-insights.title"),
      excerpt: t("introvert-insights.subtitle"),
      link: "/introvert-insights",
    },
    {
      title: t("introvert-empowerment.title"),
      excerpt: t("introvert-empowerment.subtitle"),
      link: "/introvert-empowerment",
    },
  ]

  return (
    <div className="px-4 py-8">
      <h2 className="text-xl md:text-2xl font-semibold mb-4">
        {t("highlights")}
      </h2>
      {posts.map((post, index) => (
        <div key={index} className="mb-4">
          <h4 className="text-xl mb-2">{post.title}</h4>
          <p className="mb-2">{post.excerpt}</p>
          <Link to={post.link} className="text-blue-500">
            {t("read-more")}
          </Link>
        </div>
      ))}
    </div>
  )
}

export default Highlights
